import {
  dispatchFinishAudio,
  playAudio,
  setOnFinishAudioCallback,
} from '@weblite/audio'
import {
  createBlobURL,
  downloadFile,
  getFileBlobUrlByFileId,
  getFileUrl,
} from '@weblite/file'
import { MessageSender, RawVoiceMessage } from '@weblite/ts-action/message'
import * as audioPlayerService from '$logic/audio-player'
import { getMessageByIid, getSenderName } from '$logic/message'
import { getNextAndPrevMessagesByType } from '$logic/shared-media/service'
import { createBlobCreator } from '$common/react-hooks/message'
import { clientSettingsStorage } from '$logic/client-device/storage'

setOnFinishAudioCallback(async function () {
  if (clientSettingsStorage.get()?.autoPlayAudio === false)
    return dispatchFinishAudio()
  const { roomId, iid } = audioPlayerService.getData()
  if (!roomId || !iid) return dispatchFinishAudio()
  const { type } = await getMessageByIid(roomId, iid)
  if (type !== 'VOICE') return dispatchFinishAudio()
  const { next } = await getNextAndPrevMessagesByType(roomId, iid, type)
  if (!next) return dispatchFinishAudio()
  const nextMessage = await getMessageByIid(roomId, next)

  const { duration, fileId } = (nextMessage as RawVoiceMessage).attachment
  let blobURL = getFileBlobUrlByFileId(fileId)
  const senderName = await getSenderName(nextMessage.sender as MessageSender)

  if (!blobURL) {
    blobURL = await new Promise((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      downloadFile({
        fileId,
        url: getFileUrl(fileId),
        onComplete: (file: BlobPart[]) => {
          createBlobURL(fileId, createBlobCreator(type)(file))
          resolve(getFileBlobUrlByFileId(fileId))
        },
        onError: reject,
      })
    })
  }
  playAudio(blobURL, duration / 1000, { type: 'VOICE', name: senderName })
  return audioPlayerService.setData(roomId, next)
})
